var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9604 6.12988C12.2204 6.12988 12.4704 6.22988 12.6704 6.41988L21.9804 15.7299C22.3703 16.1199 22.3703 16.7499 21.9804 17.1399C21.5904 17.5299 20.9604 17.5299 20.5704 17.1399L11.9604 8.52988L3.50035 16.9999C3.11035 17.3899 2.48035 17.3899 2.09035 16.9999C1.70035 16.6099 1.70035 15.9799 2.09035 15.5899L11.2504 6.41988C11.4504 6.21988 11.7004 6.12988 11.9604 6.12988Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow_top.03cec4fdd4bbf6eec0e25223083e11d4.svg";
export { ForwardRef as ReactComponent };